/**
 * Brand-udtrykket ([D-471], Charlie 29-10-2026): appens UI i designmanualens
 * farver og skrifter (Salvie, Lys orange, Duset lyserød m.fl.; Jost som
 * erklæret erstatning for Futura PT, Open Sans til brødtekst), stramme hjørner
 * og bløde animationer, i stedet for det monokrome udtryk fra [D-021]/[D-026].
 *
 * Standard for alle profiler siden [D-522] (Charlie 02-11-2026; før kun for
 * super_admins, der selv slog det til). Hedder "Brand 2022" i togglen på Min
 * profil, hvor alle kan vælge Klassisk i stedet. Valget gemmes pr. browser
 * (localStorage, som temaet). Selve udtrykket bor i CSS under klassen
 * `brand-ui` på <html> (styles/brand-ui.css), så ingen skabelon skal kende til
 * det; JS-siden (chart-paletten, EChartBase, tal der tæller op) læser `isBrandUi`.
 *
 * index.html sætter klassen før Vue monteres (ingen blink af Montserrat og
 * gråtoner ved reload).
 */

import { computed, watch } from 'vue';

import { state } from '../state';

export const BRAND_UI_STORAGE_KEY = 'brandUi';

/** Brand-udtrykket er aktivt lige nu. */
export const isBrandUi = computed(() => state.brandUi);

watch(
  isBrandUi,
  (on) => {
    document.documentElement.classList.toggle('brand-ui', on);
  },
  { immediate: true },
);

export function useBrandUi() {
  function setBrandUi(on: boolean): void {
    state.brandUi = on;
  }

  return { isBrandUi, setBrandUi };
}
